import { Component, ViewChild, OnInit, OnDestroy } from "@angular/core";
import { AuthService } from '@tesla/ng-auth';

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit, OnDestroy {

	constructor(
		private authModule: AuthService,
	) { }

	ngOnInit() {
		this.authModule.execute();
	}

	ngOnDestroy(): void { }
}
